import styled from "styled-components";
import { DefaultTitleLargeFactory } from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const FaqSectionContainer = styled.section(({ theme }) => ({
  borderTop: `2px solid ${theme.color.line.medium}`,
  backgroundColor: theme.color.neutral["08"],
  marginBottom: "0 !important",
  paddingTop: "40px",
  paddingBottom: "40px",

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const FaqSectionContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",

  [theme.breakpoint.lg()]: {
    gap: "40px",
  },
}));

export const FaqSectionHeader = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
}));

export const FaqSectionTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const FaqSectionList = styled.div(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: "0 64px",

  [theme.breakpoint.lg()]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
}));
